import { ApolloLink, Observable } from '@apollo/client';
const shareObservable = (observable, callbacks) => 
/*
      zen-observable does not support multicast subscriptions so we're doing a bit of work here
      to create an implementation that's similar to other observable library `do` or `share` implementations
      (https://github.com/tc39/proposal-observable/issues/66#issuecomment-601533902)

      This returns a new observable, piping source events to both the new observable and the callbacks

      This borrows heavily from the `apollo-link-error` implementation: https://github.com/apollographql/apollo-client/blob/main/src/link/error/index.ts

      Error parsing taken from `apollo-link-error. "network" errors can have GraphQL Errors as well (e.g. 403), hence the nested result lookup:
       - https://github.com/apollographql/apollo-client/blob/29cae08eb0f21cb1864ffcd4e7125e8f6d0eaa1b/src/link/error/index.ts#L37-L43
       - https://github.com/apollographql/apollo-client/blob/29cae08eb0f21cb1864ffcd4e7125e8f6d0eaa1b/src/link/error/index.ts#L57-L65
    */
new Observable((observer) => {
    let subscription;
    try {
        subscription = observable.subscribe({
            next: (result) => {
                observer.next.bind(observer)(result);
                callbacks.next &&
                    callbacks.next({
                        result,
                        graphQLErrors: result.errors,
                    });
            },
            error: (networkError) => {
                var _a;
                observer.error.bind(observer)(networkError);
                callbacks.error &&
                    callbacks.error({
                        result: networkError,
                        networkError,
                        graphQLErrors: (_a = networkError === null || networkError === void 0 ? void 0 : networkError.result) === null || _a === void 0 ? void 0 : _a.errors,
                    });
            },
            complete: () => {
                observer.complete.bind(observer)();
                callbacks.complete && callbacks.complete();
            },
        });
    }
    catch (error) {
        observer.error.bind(observer)(error);
    }
    // return maybe-subscription so zen-observable can clean it up later
    return subscription;
});
/*
  A Link used to provide an interface with which to monitor the client-side performance of operations.
*/
export const makePerformanceLink = (callback) => new ApolloLink((operation, forward) => {
    const start = performance.now();
    const onPerformanceData = (data) => {
        const metadata = Object.assign({ operationName: operation.operationName }, data);
        // We don't know the safety of the performance callback, so we're wrapping this in a try/catch
        // Any uncaught errors will cause the entire apollo request to fail, so we log and swallow any errors below
        try {
            callback(performance.now() - start, metadata);
        }
        catch (error) {
            console.error(`There was an error emitting performance data for ${operation.operationName}.`, error);
        }
        return data;
    };
    // return forward(operation).map(onPerformanceData)
    return shareObservable(forward(operation), {
        next: onPerformanceData,
        error: onPerformanceData,
    });
});
